import { createApp } from 'vue'
import Header from '@/components/organisms/TopPageHeaderOrganism.vue'
import Footer from '@/components/organisms/FooterOrganism.vue'
import App from './App.vue'

createApp(Header).mount('#header')
createApp(Footer).mount('#footer')
createApp(App).mount('#app')